/*
 * DESIGN: "Leśna Przystań" — 404 page
 */
import { Link, useLocation } from "wouter";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Home, ArrowLeft } from "lucide-react";
import PageMeta from "@/components/PageMeta";

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

export default function NotFound() {
  const [location] = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_not_found",
      page_path: location,
    });
  }, [location]);

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "oklch(0.97 0.02 90)" }}>
      <PageMeta
        title="404 – Strona nie znaleziona | Kajaki Kudłaty Cooky"
        description="Strona, której szukasz, nie istnieje. Wróć na stronę główną Kajaki Kudłaty Cooky."
        canonical="/404"
        noindex={true}
      />
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4 py-24">
        <div className="text-center max-w-lg">
          <div
            className="text-9xl font-bold mb-4"
            style={{ fontFamily: "'Playfair Display', serif", color: "oklch(0.22 0.06 155)", opacity: 0.15 }}
          >
            404
          </div>
          <div className="text-6xl mb-6">🛶</div>
          <h1
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ fontFamily: "'Playfair Display', serif", color: "oklch(0.22 0.06 155)" }}
          >
            Ups! Zgubiłeś się na rzece?
          </h1>
          <p
            className="text-gray-600 mb-8 leading-relaxed"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Strona, której szukasz, nie istnieje lub została przeniesiona. Wróć na stronę główną i zarezerwuj swój spływ!
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link href="/" className="btn-ember">
              <Home size={16} />
              Strona główna
            </Link>
            <Link href="/rezerwacja" className="btn-forest">
              <ArrowLeft size={16} />
              Zarezerwuj spływ
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
